namespace Matrix.DataAudit {
    export interface SecurityHistoryForm {
        Name: Serenity.StringEditor;
        Issuer: Serenity.LookupEditor;
        SecurityCode: Serenity.StringEditor;
        SecurityTypeCode: Serenity.LookupEditor;
        LocalCurrencyCode: Serenity.LookupEditor;
        AssociatedAccountCode: FormatServiceLookupEditor;
        CountryOfIssueCode: Serenity.LookupEditor;
        CountryOfRiskCode: Serenity.LookupEditor;
        CurrencyOfRiskCode: Serenity.LookupEditor;
        Generation: Serenity.IntegerEditor;
        IsCurrent: Serenity.StringEditor;
        CurrentFrom: Serenity.StringEditor;
        CurrentTo: Serenity.StringEditor;
        Sedol: Serenity.StringEditor;
        RIC: Serenity.StringEditor;
        Isin: Serenity.StringEditor;
        Cusip: Serenity.StringEditor;
        Figi: Serenity.StringEditor;
        Ticker: Serenity.StringEditor;
        InternalSecurityCode: Serenity.StringEditor;
        SecurityId: Serenity.IntegerEditor;
        DealParentCode: Serenity.StringEditor;
        ClearerReference: Serenity.StringEditor;
        RedCode: Serenity.StringEditor;
        SpLtRating: Serenity.LookupEditor;
        SpStRating: Serenity.LookupEditor;
        MoodysLtRating: Serenity.LookupEditor;
        MoodysStRating: Serenity.LookupEditor;
        FitchLtRating: Serenity.LookupEditor;
        FitchStRating: Serenity.LookupEditor;
        InternalLtRating: Serenity.StringEditor;
        InternalStRating: Serenity.StringEditor;
        CouponRate: Serenity.DecimalEditor;
        MaturityDate: Serenity.DateEditor;
        FixedOrFloat: Serenity.StringEditor;
        FloatIndex: Serenity.StringEditor;
        InflationIndexLag: Serenity.StringEditor;
        InterestTerm: Serenity.StringEditor;
        Spread: Serenity.DecimalEditor;
        AllIn: Serenity.DecimalEditor;
        InterestCcy: Serenity.LookupEditor;
        PaymentFrequency: Serenity.StringEditor;
        PaymentBusDayConvention: Serenity.StringEditor;
        PaymentCalendar: Serenity.StringEditor;
        FirstPaymentDate: Serenity.DateEditor;
        DayCountBasis: Serenity.StringEditor;
        ResetFrequency: Serenity.StringEditor;
        ResetBusDayConvention: Serenity.StringEditor;
        ResetCalendar: Serenity.StringEditor;
        CreditEvents: Serenity.StringEditor;
        Guarantor: Serenity.StringEditor;
        TradeDate: Serenity.DateEditor;
        EffectiveDate: Serenity.DateEditor;
        BrokerCode: FormatLookupEditor;
        BrokerName: Serenity.StringEditor;
        Strategy: Serenity.StringEditor;
        OptionStyle: Serenity.StringEditor;
        ExerciseStyle: Serenity.StringEditor;
        PutOrCall: Data.ListEditor;
        StrikePrice: Serenity.DecimalEditor;
        StrikeCurrency: Serenity.StringEditor;
        Premium: Serenity.DecimalEditor;
        PremiumCcy: Serenity.LookupEditor;
        PayOrRec: Serenity.StringEditor;
        BorrowerCode: FormatLookupEditor;
        UnderlyerName: Serenity.StringEditor;
        UnderlyerCcy: Serenity.LookupEditor;
        UnderlyerType: Serenity.StringEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        SourceCreatedBy: StaticTextBlock;
        SourceCreatedWhen: ReadOnlyDateTime;
        SourceUpdatedBy: StaticTextBlock;
        SourceUpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class SecurityHistoryForm extends Serenity.PrefixedContext {
        static formKey = 'DataAudit.SecurityHistory';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!SecurityHistoryForm.init)  {
                SecurityHistoryForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;
                var w2 = FormatServiceLookupEditor;
                var w3 = s.IntegerEditor;
                var w4 = s.DecimalEditor;
                var w5 = s.DateEditor;
                var w6 = FormatLookupEditor;
                var w7 = Data.ListEditor;
                var w8 = StaticTextBlock;
                var w9 = ReadOnlyDateTime;

                Q.initFormType(SecurityHistoryForm, [
                    'Name', w0,
                    'Issuer', w1,
                    'SecurityCode', w0,
                    'SecurityTypeCode', w1,
                    'LocalCurrencyCode', w1,
                    'AssociatedAccountCode', w2,
                    'CountryOfIssueCode', w1,
                    'CountryOfRiskCode', w1,
                    'CurrencyOfRiskCode', w1,
                    'Generation', w3,
                    'IsCurrent', w0,
                    'CurrentFrom', w0,
                    'CurrentTo', w0,
                    'Sedol', w0,
                    'RIC', w0,
                    'Isin', w0,
                    'Cusip', w0,
                    'Figi', w0,
                    'Ticker', w0,
                    'InternalSecurityCode', w0,
                    'SecurityId', w3,
                    'DealParentCode', w0,
                    'ClearerReference', w0,
                    'RedCode', w0,
                    'SpLtRating', w1,
                    'SpStRating', w1,
                    'MoodysLtRating', w1,
                    'MoodysStRating', w1,
                    'FitchLtRating', w1,
                    'FitchStRating', w1,
                    'InternalLtRating', w0,
                    'InternalStRating', w0,
                    'CouponRate', w4,
                    'MaturityDate', w5,
                    'FixedOrFloat', w0,
                    'FloatIndex', w0,
                    'InflationIndexLag', w0,
                    'InterestTerm', w0,
                    'Spread', w4,
                    'AllIn', w4,
                    'InterestCcy', w1,
                    'PaymentFrequency', w0,
                    'PaymentBusDayConvention', w0,
                    'PaymentCalendar', w0,
                    'FirstPaymentDate', w5,
                    'DayCountBasis', w0,
                    'ResetFrequency', w0,
                    'ResetBusDayConvention', w0,
                    'ResetCalendar', w0,
                    'CreditEvents', w0,
                    'Guarantor', w0,
                    'TradeDate', w5,
                    'EffectiveDate', w5,
                    'BrokerCode', w6,
                    'BrokerName', w0,
                    'Strategy', w0,
                    'OptionStyle', w0,
                    'ExerciseStyle', w0,
                    'PutOrCall', w7,
                    'StrikePrice', w4,
                    'StrikeCurrency', w0,
                    'Premium', w4,
                    'PremiumCcy', w1,
                    'PayOrRec', w0,
                    'BorrowerCode', w6,
                    'UnderlyerName', w0,
                    'UnderlyerCcy', w1,
                    'UnderlyerType', w0,
                    'CreatedBy', w8,
                    'CreatedWhen', w9,
                    'UpdatedBy', w8,
                    'UpdatedWhen', w9,
                    'SourceCreatedBy', w8,
                    'SourceCreatedWhen', w9,
                    'SourceUpdatedBy', w8,
                    'SourceUpdatedWhen', w9,
                    'Version', w8
                ]);
            }
        }
    }
}
